import React from 'react';
import StartScreen from './screens/startScreen';
import MainContent from './screens/mainScreen';
import ReactGA from 'react-ga4';
import { AppProvider } from './utility/AppProvider';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

ReactGA.initialize('G-FMPPBZQ1LD');
function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<StartScreen />} />
            <Route path="/graph" element={<MainContent />} />
          </Routes>
        </div>
      </AppProvider>
    </BrowserRouter>
  );
}

export default App;
